import registerReduxModal from 'components/common/hoc/registerReduxModal'
import { SHARE_VIA_EMAIL_MODAL } from 'constant'
import ShareViaEmailModal from './ShareViaEmailModal'

export default registerReduxModal({ name: SHARE_VIA_EMAIL_MODAL })(ShareViaEmailModal)
